import "./module/userAgentChecker.js"
import "./module/plugin.js"

import Swiper from 'swiper/bundle';
var swiper01 = new Swiper(".mv__slider", {
    effect: "fade",
    speed: 3500,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
});

var swiper02 = new Swiper('.post__containerPdFigSlider');

var $ = require('jquery');
// slideToメソッドを実行する関数を定義
$('.post__containerPdFigThumBoxIn').on('click', function(){
  var elm = $(this).parent().index();
  swiper02.slideTo(elm);
  $(this).parent().toggleClass('active');
  $('.post__containerPdFigThumBoxIn').not(this).parent().removeClass('active');
});

import ScrollMagic from 'scrollmagic';
class ScrollFade {
  constructor() {
      this.ANIMATION_CLASS = 'is-animation';

      let $section = document.querySelectorAll('.js-scroll:not(.is-animation)');
      if($section.length === null) {
          return;
      }
      let controller = new ScrollMagic.Controller();
      for(let i = 0; i < $section.length; i++) {
          let scene = new ScrollMagic.Scene({
              triggerElement: $section[i],
              triggerHook: 'onEnter',
              reverse: false,
              offset: 100
          })
              .addTo(controller);
          scene.on('enter', ()=>{
              $section[i].classList.add(this.ANIMATION_CLASS);
          });
          scene.on('end', ()=>{
              scene.destroy(true);
          });
      }
  }
}

new ScrollFade();

require('picturefill');

import objectFitImages from 'object-fit-images';
objectFitImages();